export const ArrowRightSolid = ({className}) => {
  return (
<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M6.70615 0.293457C6.31553 -0.097168 5.68115 -0.097168 5.29053 0.293457L1.29053 4.29346C0.899902 4.68408 0.899902 5.31846 1.29053 5.70908C1.68115 6.09971 2.31553 6.09971 2.70615 5.70908L4.9999 3.41533V14.9997C4.9999 15.5528 5.44678 15.9997 5.9999 15.9997C6.55303 15.9997 6.9999 15.5528 6.9999 14.9997V3.41533L9.29365 5.70908C9.68428 6.09971 10.3187 6.09971 10.7093 5.70908C11.0999 5.31846 11.0999 4.68408 10.7093 4.29346L6.70928 0.293457H6.70615Z" />
</svg>

  );
};